export default {"src":"/nachrichten/_next/static/media/favicon.0acdf33e.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};